module.exports = __webpack_public_path__ + "static/media/bingo-caller.e070b5aa.png";